var React = require('react');

function Mp3Player (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M336 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zM192 448a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm128-256H64V64h256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 64v128h256V64zm128 192a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 128a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-primary","key":2})]);
}

Mp3Player.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Mp3Player;

Mp3Player.default = Mp3Player;
